
export const openMap = () => {
    if (window.$$) {
        window.$$('openMap').fire();
    } else {
        alert('$$ not ready');
    }
}

export const openMapComposition = (hashId) => {
    if (window.$$) {
        window.$$('openMap').fire({ action: 'openMapComposition', cmp: {hash: hashId}});
    } else {
        alert('$$ not ready');
    }
};

export const openSearchResult = (result) => {
    if (window.$$) {
        window.$$('openMap').fire({ action: 'openSearchResult', result});
    } else {
        alert('$$ not ready');
    }
}

export const openUP = (layerIds, bbox) => {
    if (window.$$) {
        window.$$('openMap').fire({ action: 'openMunic',
            municipality: {
                layerIds: layerIds,
                bbox: bbox
            }});
    } else {
        alert('$$ not ready');
    }
}

export const addItemToBasket = (productId) => {
    if (window.$$$) {
        return window.$$('openMap').fire({ action: 'addItemToCart', productId: productId });
    } else {
        alert('$$ not ready');
    }
}

export const getThemesPromise = (type, bbox) => {
    if (window.$$$) {
        return window.$$$('Share_GetList',  { type: type, bbox: bbox } )();
    }
}

export const getPersonalizedThemesPromise = (limit) => {
    if (window.$$$) {
        return window.$$$('Share_GetList',  { personalize: 1, limit } )();
    }
}

export const getStatistics = () => {
    if (window.$$$) {
        return window.$$$('Stats_Get')();
    }
}

export const searchFulltext = (searchValue) => {
    if (window.$$) {
        return new Promise((resolve, reject)=> {
            window.$$('directSearch').fire(searchValue, resolve, reject);
        });
    } else {
        return new Promise((resolve)=> {
            setTimeout(() => {
                resolve(
                    [{"id":3535,"displayName":"Topografická mapa"},{"id":3537,"displayName":"Štandardná mapa "},{"id":3539,"displayName":"Cyklistická mapa"}]
                );
            }, 2000);
        });
    }
};

export const searchPlan = (searchValue) => {
    if (window.$$$) {
        return window.$$$('Municipality_Search', { phrase: searchValue, maxResults: 5 } )();
    }
};

export const getRegions = (id) => {
    if (window.$$$) {
        if (id) {
            return window.$$$('Municipality_GetByUrl',  {url: id} )();
        } else {
            return window.$$$('Municipality_GetByUrl',  {} )();
        }
    }
}

export const getRegion = (url) => {
    if (window.$$$) {
        if (url) {
            return window.$$$('Municipality_Get',  {url: url} )();
        } else {
            return false;
        }
    }
}

export const getImageThemeUrl = (theme) => {
    if (window.$$ === null) {
        var urls = [
            'https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Mapa_del_Virreinato_de_la_Nueva_Espa%C3%B1a_%281794%29.svg/280px-Mapa_del_Virreinato_de_la_Nueva_Espa%C3%B1a_%281794%29.svg.png',
            'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Mapa_del_%C3%81frica_colonial_%281947%29.svg/508px-Mapa_del_%C3%81frica_colonial_%281947%29.svg.png',
            'https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Mapa_del_Territorio_Muisca.svg/473px-Mapa_del_Territorio_Muisca.svg.png',
            'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Czech_Republic_location_map.svg/640px-Czech_Republic_location_map.svg.png',
            'https://upload.wikimedia.org/wikipedia/commons/a/a9/Long_and_Loop_Street_map.svg'
        ];

        return urls[Math.floor(Math.random() * (4 - 0 + 1) + 0)];
    }
    return `https://mapsfy.com/ashx/fileProxy.ashx?relId=${theme.hash}&f=${theme.imgToken}&w=250`;
}

export const getImageFileUrl = (f) => {
    if (window.SETTINGS && window.SETTINGS.fileProxyUrl) {
        return `${window.SETTINGS.fileProxyUrl}${f}`;
    } else {
        return 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Long_and_Loop_Street_map.svg';
    }
}

export const recoverPassword = (name) => {
    alert('TODO recoverPassword: ', name);
}

export const attemptLogin = (name, pass) => {
    if (window.$$) {
        window.$$('landingPageLogin').fire(name, pass);
    }
}

export const loginFacebook = (name, pass) => {
    if (window.$$) {
        window.$$('landingPageLoginFacebook').fire(name, pass);
    }
}

export const loginGoogle = (name, pass) => {
    if (window.$$) {
        window.$$('landingPageLoginGoogle').fire(name, pass);
    }
}

export const logout = () => {
    if (window.$$) {
        window.$$('landingPageLogout').fire()
    }
}

export const onLoginError = (callback) => {
    if (window.$$) {
        window.$$('loginIncorrect').listen(callback);
    }
}

export const removeOnLoginError = (callback) => {
    if (window.$$) {
        window.$$('loginIncorrect').remove(callback);
    }
}

export const sendFeedBack = ({email, message}) => {
    if (window.$$$) {
        return window.$$$('Feedback_Send', { email: email, message: message })();
    }
}

export const registerToWorkshop = ({workshop, name, surname, email, phone, message}) => {
    if (window.$$$) {
        return window.$$$('Workshop_Register', {workshop, name, surname, email, phone, message})();
    }
}

export const requestWorkshop = ({name, surname, email, phone, message}) => {
    if (window.$$$) {
        return window.$$$('Workshop_Request', {name, surname, email, phone, message})();
    }
}


export class GlobalListenersManager {
    constructor(store) {
        this.store = store;
        this.callbackAccount_Describe = this.callbackAccount_Describe.bind(this);
        this.callbackShoppingCartChange = this.callbackShoppingCartChange.bind(this);

        const isDemoLoggedId = false;

        if (!window.$$ && isDemoLoggedId) {
            const res = [{"id":1732,"login":"ja@ludvikadamec.cz","a":false,"b":false,"name":"ja","surname":"Adamec","nick":"ja Adamec","roleName":"User","email":"ja@ludvikadamec.cz","phone":"","street":"","number":"","city":"","state":"","zip":"","avatar":"ac4b4323-5684-a273-75e4-5165228de248","cookieAllowed":false,"licenceAgreed":true,"newsAgreed":false,"mmNewsAgreed":false,"partnersNewsAgreed":false,"legendState":[{"i":"sg6","c":0,"v":1},{"i":1,"v":0,"c":1,"o":4},{"i":"1-1","v":1},{"i":"1-1452","v":0},{"i":"1-1830","v":0},{"i":"sg2","c":0,"v":1},{"i":"138","c":0,"v":1},{"i":"102","c":1},{"i":"sg1","c":0,"v":1},{"i":"6","c":1,"v":0},{"i":171,"v":1,"c":0},{"i":"175","c":1},{"i":"172","c":1},{"i":"171-3258","v":1},{"i":"182","c":1,"v":0},{"i":"186","c":1,"v":1},{"i":"187","c":1,"v":0},{"i":"187-3363","v":0},{"i":"187-3366","v":1},{"i":"187-3364","v":0},{"i":188,"v":0},{"i":190,"v":0},{"i":"186-3357","v":1},{"i":"186-3421","v":0},{"i":"186-3356","v":0},{"i":"186-3418","v":0},{"i":"186-3355","v":0},{"i":"186-3358","v":0},{"i":"186-3359","v":0},{"i":"186-3353","v":0},{"i":"186-3352","v":0},{"i":"186-3354","v":0},{"i":"186-3360","v":0},{"i":"186-3361","v":0},{"i":"1-3431","v":0},{"i":"1-3433","v":0},{"i":"1-3432","v":0},{"i":"1-3434","v":0},{"i":"201","c":0,"v":1},{"i":"202","c":0,"v":1},{"i":"187-3365","v":1},{"i":"203","c":1,"v":0},{"i":"202-3488","v":0},{"i":"104","c":1,"v":0},{"i":"160","c":0,"v":1},{"i":100,"v":1},{"i":101,"v":1},{"i":"160-3217","v":0},{"i":"186-3417","v":0},{"i":"152","c":0},{"i":"206","c":1,"v":0},{"i":"201-1","v":0},{"i":"201-3431","v":1},{"i":"201-3433","v":0},{"i":"201-3432","v":0},{"i":"201-1452","v":0},{"i":"201-1830","v":0},{"i":"201-3537","v":0},{"i":"201-5855","v":0},{"i":"1768-6469","v":0},{"i":1768,"v":0,"c":0},{"i":"1768-6471","v":0},{"i":"1793","c":1,"v":0},{"i":1089,"v":0,"c":1},{"i":97,"v":0,"o":3},{"i":2599,"v":0,"c":1},{"i":"378","c":1,"v":1,"x":1},{"i":2598,"v":0,"c":1},{"i":"201-3536","v":0},{"i":"201-6898","v":1},{"i":"2603","c":1,"v":0},{"i":"1387","c":0,"v":1},{"i":"2","c":0,"v":0},{"i":159,"v":0},{"i":"158","c":1,"v":0},{"i":"201-6910","v":0},{"i":"2600","c":1,"v":0},{"i":"2600-5320","v":1,"o":0},{"i":"2600-6707","v":1,"o":1},{"i":"378-3776","v":1},{"i":"378-3772","v":1,"x":1},{"i":"378-3774","v":1},{"i":"201-6909","v":0},{"i":"201-6905","v":0},{"i":"1107","c":1,"v":0},{"i":"1108","c":1,"v":0},{"i":"1108-4925","v":1},{"i":"1108-4924","v":1},{"i":"1108-4923","v":1},{"i":"1108-4922","v":1},{"i":"1108-4921","v":1},{"i":"1108-4920","v":1},{"i":"1108-4919","v":1},{"i":"1108-4918","v":1},{"i":"1108-4917","v":1},{"i":"201-3543","v":0},{"i":"2596","c":0,"v":1},{"i":"2596-6534","v":0},{"i":"2601","c":1,"v":0},{"i":"2601-3488","v":1},{"i":"2604","c":1,"v":0},{"i":"2604-6535","v":1},{"i":"1119","c":1},{"i":"1099","c":1,"v":0},{"i":"1102","c":0,"v":1},{"i":"1102-4884","v":1},{"i":"2596-6533","v":0},{"i":"2602","c":1,"v":0},{"i":"2602-7102","v":1},{"i":1181,"v":0,"c":1},{"i":1736,"v":0,"c":1},{"i":"1736-7815","v":1},{"i":1378,"v":1,"c":0},{"i":"1378-5707","v":1},{"i":"1378-8062","v":0,"op":1},{"i":"2174","c":1},{"i":"1378-5721","v":0},{"i":"1378-8063","v":0},{"i":"1378-5724","v":1},{"i":"1378-8068","v":0},{"i":"2116","c":1,"v":0},{"i":"2116-7113","v":0},{"i":"2332","c":1},{"i":2621,"v":0,"c":0},{"i":"2621-8070","v":1,"o":1},{"i":"2621-8071","o":0,"v":1},{"i":"2116-7109","v":0},{"i":2624,"v":0,"c":1,"o":0},{"i":"2624-8071","o":0,"v":0},{"i":"2624-8073","o":1,"v":0},{"i":"2624-8074","o":2,"v":0},{"i":"2624-8076","o":3,"v":0},{"i":"1-8077","v":0},{"i":"2624-8077","o":4,"v":0},{"i":"1793-6873","v":1},{"i":"1-5319","v":0},{"i":"1-7854","v":0},{"i":"2624-8078","o":5,"v":0},{"i":"2624-8079","o":6,"v":0,"op":0},{"i":"1075","o":1,"v":0,"x":1},{"i":"452","o":2},{"i":"1-8081","v":0},{"i":"2624-8081","o":7,"v":0,"op":1},{"i":"2624-8085","o":8,"v":0,"op":1},{"i":2625,"v":0,"o":1,"c":1},{"i":"2621-8087","o":1},{"i":"2625-8087","o":0,"v":0},{"i":"2621-8088","o":2},{"i":"2625-8088","o":1,"v":0},{"i":"1-8089","v":1},{"i":"2625-8089","o":2,"v":1},{"i":"2621-8092","v":0},{"i":"2621-8093","v":1},{"i":"2621-8094","v":1},{"i":"2606","c":1},{"i":"1-8095","v":1},{"i":"1-8096","v":1},{"i":"2116-7681","v":0},{"i":"1-8097","v":1},{"i":"1378-8086","v":0},{"i":"1378-8084","v":0},{"i":"1378-8083","v":0},{"i":"1378-8082","v":0},{"i":"1378-8072","v":0},{"i":"1378-8075","v":0},{"i":"1378-8069","v":0},{"i":"1378-8080","v":0},{"i":"1378-5820","v":1},{"i":"1378-8101","v":0,"op":1},{"i":"1378-8102","v":0},{"i":"1378-5786","v":0},{"i":"1378-8103","v":0},{"i":"1378-8104","v":0},{"i":"1378-5788","v":0},{"i":"1378-5790","v":0},{"i":"1378-8105","v":0},{"i":"1378-5791","v":0},{"i":"1378-8106","v":0},{"i":"1378-5794","v":1},{"i":"1378-8107","v":0},{"i":"1378-5812","v":1},{"i":"1378-8108","v":0},{"i":"1378-5813","v":1},{"i":"1378-8109","v":0},{"i":"1378-5814","v":1},{"i":"1378-8110","v":0},{"i":"1378-5816","v":0},{"i":"1378-8111","v":0},{"i":"1378-5818","v":1},{"i":"1378-8112","v":1},{"i":"1181-5706","v":0},{"i":"1378-5782","v":0},{"i":"1378-5725","v":1},{"i":"1378-8113","v":1},{"i":"1125","c":1,"v":0},{"i":"1129","c":1,"v":1},{"i":"2596-4720","v":0},{"i":"2596-4719","v":1},{"i":"201-3535","v":1},{"i":"5719-6471","v":true,"eo":3},{"i":"5719-6469","v":true,"eo":4},{"i":"2308-7529","v":true,"eo":2},{"i":5721,"v":1},{"i":"5721-3772","v":true,"eo":0},{"i":"5721-3774","v":true,"eo":1},{"i":"1361","c":1}],"lastView":{"lon":2305821.7890508,"lat":6243329.0626149,"z":15},"explicitRights":[],"mustAgree":0,"auditEvents":["renderWidgetToTile","btnClick","leftPanelToolbarBtnClicked","renderToTile","mapkaOpened","search","print","layersClick","homeClick","mapkaFormClicked","headerClicked","mapClick"],"resourceConstraint":"","legalConstraint":"","nipiCompatible":false,"nipi":false,"showAds":1,"dogsLeft":5,"nipiPassword":"","theme":1,"created":"08/08/2018 16:27:13","last_update":"01/15/2020 11:10:57","measureUnits":0,"hasPro":false,"subdomain":"","allowBankTransfer":false,"favoriteLayers":[],"searchHistory":"","rights":[]}];
            this.callbackAccount_Describe(res);
        }
    }

    callbackAccount_Describe(res) {
        console.log('callbackAccount_Describe: ', res);
        if (res && res[0] && res[0].login !== "Anonym") {
            this.store.dispatch('auth/setAccountDetail', res);
        }
    }

    callbackShoppingCartChange(result, state) {
        if (state === true && result) {
            this.store.dispatch('basket/setBasket', result);
        } else {
            this.store.dispatch('basket/setBasketState', {state: false});
        }
    }

    createListeners() {
        if (window.$$) {
            window.$$('Account_Describe', 'memory').listen(this.callbackAccount_Describe);
            window.$$('shoppingCartChange', 'memory').listen(this.callbackShoppingCartChange);
        }
    }

    removeListeners() {
        if (window.$$) {
            window.$$('Account_Describe').remove(this.callbackAccount_Describe)
            window.$$('shoppingCartChange').remove(this.callbackShoppingCartChange)
        }
    }
}

export default () => {
    return (method, params) => {
        let Share_GetList = [{"imgToken":"f73fa3b4-95d4-dbc1-b1a1-6e09307a76fe","name":"Svet - Počasie / Webkamery","hash":"27A095D6","panelNo":2},{"imgToken":"27d5d95b-7e5b-4e72-1034-5975cc4f1d34","name":"Svet - Turistické trasy","hash":"6F5E82B4","panelNo":2},{"imgToken":"e62c3bcf-3ac0-a4d9-9a14-ee8a21a4d667","name":"Svet - Cyklistické trasy","hash":"C073E534","panelNo":2},{"imgToken":"c98e1a6a-d625-cc98-a476-4bd139e48049","name":"Svet - Seizmické udalosti","hash":"A3DA64DE","panelNo":2},{"imgToken":"8dd04d24-885b-d29f-eb70-6c768386182a","name":"EU - Výškový model","hash":"220F8FCF","panelNo":2},{"imgToken":"25495f2b-0d07-30ac-d576-f214c96dbe07","name":"EU - Atlas využívania pôdy","hash":"DBDE7AEC","panelNo":2},{"imgToken":"4d603a91-52d5-91cd-94ac-c113e2b0d445","name":"Svet - Parkovanie","hash":"19870D92","panelNo":3},{"imgToken":"077f5857-3b34-5597-79ea-1e8d12519935","name":"Svet - Reštaurácie a bary","hash":"39B510BA","panelNo":3},{"imgToken":"63da5650-1b65-9562-ac5a-57b87185a42c","name":"Svet - Tankovanie a nabíjanie","hash":"2BABD469","panelNo":3},{"imgToken":"dbacbd46-072e-f56f-b9f4-0ba1097ce2fb","name":"Svet - Bankomaty","hash":"D20870D1","panelNo":3},{"imgToken":"6ef3c44e-759d-d8ac-e9d0-34ffe448c1a5","name":"Svet - Lekáreň","hash":30840826,"panelNo":3},{"imgToken":"38fbcb85-daa8-5890-c7f6-67677b614db3","name":"Svet - Ubytovanie","hash":"3F7567DE","panelNo":3},{"imgToken":"08c251ea-ffd7-c973-1e15-21d76fb8a0c2","name":"SK - Územné plány (okres IL)","hash":"12801C7B","panelNo":3},{"imgToken":"4f7e36b5-a5c4-797f-1fd4-261aafbe358c","name":"SK - Územné plány (okres KK)","hash":"92245D10","panelNo":3},{"imgToken":"b824d305-97d1-77ba-9e59-2707a18a9097","name":"SK - Územné plány (okres SA)","hash":"0A0B635F","panelNo":3},{"imgToken":"4f39bdd3-6f63-f201-b470-97b0a1325270","name":"SK - Územné plány (okres MT)","hash":"D9842D9B","panelNo":3},{"imgToken":"3ec51ea8-654e-4c0e-3fda-d794c4ec50a6","name":"SK - Diely pôdnych blokov","hash":"55D00EC0","panelNo":2},{"imgToken":"88fcb10a-2717-4475-c72a-ca5f6592375a","name":"SK - Ortofotomapa","hash":"9C92783E","panelNo":2},{"imgToken":"0f2e0fe5-e16d-b960-ff64-ac7f7846f01c","name":"SK - Kataster","hash":"A622F517","panelNo":2},{"imgToken":"39fc3c44-35fb-02de-cdc2-73b4cf969e4e","name":"SK - Kataster / ortofoto","hash":"7E5D0F66","panelNo":2},{"imgToken":"920efd07-2bc3-a808-1b9e-fba98888d69f","name":"SK - Ref. geodetické body","hash":"662A2B53","panelNo":2},{"imgToken":"0f18f737-5010-95cc-d7ff-204c5fd26dc9","name":"SK - Digitálny model reliéfu 3","hash":"5379F6B9","panelNo":2},{"imgToken":"81160988-d961-36f4-3286-7437dd7d3884","name":"SK - Historické mapy","hash":"F5370AF6","panelNo":2},{"imgToken":"c92a61a5-b421-bb23-a71f-fe512ffb9ae5","name":"SK - Hrady a zámky","hash":"63D28A6A","panelNo":2},{"imgToken":"c2c2abde-36e3-f59b-bc35-0198d54be32d","name":"SK - Aquaparky","hash":"76B523F9","panelNo":2},{"imgToken":"208844d9-b008-a169-d3a4-f6d487fb0969","name":"SK - Skládky odpadu","hash":"7D137944","panelNo":2},{"imgToken":"a549d37a-5848-f682-87ba-c118c27e54d4","name":"SK - Úložiská ťaž. odpadu","hash":"7D0E26B8","panelNo":2},{"imgToken":"4c0c6d46-781c-a1d5-0361-6d058a171180","name":"SK - Chránené územia","hash":"9F693468","panelNo":2},{"imgToken":"344936ce-c70e-4425-a92d-8e0be288708b","name":"SK - Krajinná pokrývka","hash":"EBB2B756","panelNo":2},{"imgToken":"2a8c7aeb-f1c0-cae3-41ee-b00712f58801","name":"SK - Svahové deformácie","hash":"838E623E","panelNo":2},{"imgToken":"a0dea23d-88a4-1d33-f8d3-ecb689b7eb35","name":"SK - Podzemná voda","hash":"F7D510FD","panelNo":2},{"imgToken":"2d47d2c9-ae4b-d95b-1bfd-df2941c6f5e8","name":"SK - Magnetická mapa","hash":"D60D11A3","panelNo":2}];
        let SearchResults = [{"id":3535,"compositionId":201,"name":"Topografická mapa","minScale":"","maxScale":"","sourceType":"xyz","bbox":"FULLGLOBE"}, {"id":3537,"compositionId":201,"name":"Štandardná mapa ","minScale":"","maxScale":"","sourceType":"xyz","bbox":"FULLGLOBE"}, {"id":3539,"compositionId":201,"name":"Cyklistická mapa","minScale":"","maxScale":"","sourceType":"xyz","bbox":"FULLGLOBE"}, {"id":3541,"compositionId":201,"name":"Dopravná mapa","minScale":"","maxScale":"","sourceType":"xyz","bbox":"FULLGLOBE"}, {"id":3543,"compositionId":201,"name":"Outdoorová mapa","minScale":"","maxScale":"","sourceType":"xyz","bbox":"FULLGLOBE"}, {"id":3544,"compositionId":201,"name":"Dopravná mapa 2","minScale":"","maxScale":"","sourceType":"xyz","bbox":"FULLGLOBE"}];
        let Municipality1 = [{"id":349022,"name":"Banskobystrický","url":"banskobystricky-kraj"},{"id":349023,"name":"Bratislavský","url":"bratislavsky-kraj"},{"id":349024,"name":"Košický","url":"kosicky-kraj"},{"id":349025,"name":"Nitriansky","url":"nitriansky-kraj"},{"id":349026,"name":"Prešovský","url":"presovsky-kraj"},{"id":349027,"name":"Trenčiansky","url":"trenciansky-kraj"},{"id":349028,"name":"Trnavský","url":"trnavsky-kraj"},{"id":349029,"name":"Žilinský","url":"zilinsky-kraj"}];
        let Municipality2 = [{"id":349082,"name":"Bánovce nad Bebravou","url":"okres-banovce-nad-bebravou","hasPlan":0,"municipalityId":"1"},{"id":349083,"name":"Ilava","url":"okres-ilava","hasPlan":1,"municipalityId":"1"},{"id":349084,"name":"Myjava","url":"okres-myjava","hasPlan":1,"municipalityId":"1"},{"id":349085,"name":"Nové Mesto nad Váhom","url":"okres-nove-mesto-nad-vahom","hasPlan":0,"municipalityId":"1"},{"id":349086,"name":"Partizánske","url":"okres-partizanske","hasPlan":0,"municipalityId":"1"},{"id":349087,"name":"Považská Bystrica","url":"okres-povazska-bystrica","hasPlan":0,"municipalityId":"1"},{"id":349088,"name":"Prievidza","url":"okres-prievidza","hasPlan":0,"municipalityId":""},{"id":349089,"name":"Púchov","url":"okres-puchov","hasPlan":0,"municipalityId":""},{"id":349090,"name":"Trenčín","url":"okres-trencin","hasPlan":1,"municipalityId":""}];
        let Municipality_Get = [{"name":"Žilina","web":"http://www.zilina.sk","mayor":"Ing. Igor  Liška","office_name":"Metský úrad","office_street":"Nám. obetí komunizmu 1","office_city":"Žilina","office_zip_code":"011 31 Žilina","phone":"041 / 706 01 11","email":"sekretariatmsu@zilina.sk", "hasPlan": 1}];
        let Municipality_Search = [{"id":392495,"name":"Borša","url":"borsa","fullUrl":"kosicky-kraj/okres-trebisov/borsa","hasPlan":0,"municipalityId":541},{"id":392789,"name":"Bôrka","url":"borka","fullUrl":"kosicky-kraj/okres-roznava/borka","hasPlan":0,"municipalityId":477},{"id":394400,"name":"Borová","url":"borova","fullUrl":"trnavsky-kraj/okres-trnava/borova","hasPlan":0,"municipalityId":322},{"id":393333,"name":"Zborov","url":"zborov","fullUrl":"presovsky-kraj/okres-bardejov/zborov","hasPlan":1,"municipalityId":703},{"id":394319,"name":"Borovce","url":"borovce","fullUrl":"trnavsky-kraj/okres-piestany/borovce","hasPlan":0,"municipalityId":449}];
        let Stats_Get = [{"poiLayers":500,"mapTools":23,"registeredUsers":4786,"baseMaps":18,"yearsExistence":6,"amenities":121,"urbanPlans":332,"touristAttractions":41}];
        let directSearch = [];

        Promise.prototype.fail = () => {};

        const fn = () => {
            switch(method) {
                case "Share_GetList":
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            resolve(Share_GetList);
                        }, 1500);
                    })

                case "SearchFulltext":
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            resolve(SearchResults);
                        }, 400)
                    })

                case "Municipality_Get":
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            resolve(Municipality_Get)
                        }, 1400)
                    })

                case "Municipality_Search":
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            resolve(Municipality_Search)
                        }, 1400)
                    })

                case "Municipality_GetByUrl":
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            if (params.url) {
                                resolve(Municipality2)
                            } else {
                                resolve(Municipality1);
                            }
                        }, 1400)
                    })

                case "directSearch":
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            resolve(directSearch)
                        }, 1400)
                    })

                case "Workshop_Register":
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            resolve([])
                        }, 3500)
                    })

                case "Workshop_Request":
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            resolve([])
                        }, 3500)
                    })


                case "Stats_Get":
                    return new Promise(function(resolve) {
                        setTimeout(function() {
                            resolve(Stats_Get)
                        }, 800)
                    })

                default:

            }
        }
        return fn;
    };
};
